import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
const appInsightsAdmin = import.meta.env.VITE_APPINSIGHTS_CLIENT_ADMIN;
export const applicationInsights = new ApplicationInsights({
    config: {
        instrumentationKey: appInsightsAdmin,
        enableAutoRouteTracking: true,
        extensions: [reactPlugin],
    },
});
applicationInsights.loadAppInsights();

export default (Component) => withAITracking(reactPlugin, Component);
